import { Routes } from '@angular/router';
import { BlankComponent } from './shared/layouts/blank/blank.component';
// import { FullComponent } from './layouts/full/full.component';
import { FullComponent } from './shared/layouts/full/full.component';

// import { AgentListComponent } from './pages/agent-list/agent-list.component';
import { AgentListComponent } from './shared/pages/agent-list/agent-list.component';

import { LeadsListComponent } from './shared/pages/leads-list/leads-list.component';
import { UserListComponent } from './routes/user-list/user-list.component';
import { LeaderBoardListComponent } from './routes/leader-board-list/leader-board-list.component';
import { UserRecordingComponent } from './routes/user-recordings/user-recording.component';
import { TutorialListComponent } from './routes/tutorial/tutorial-list/tutorial-list.component';
import { DashboardComponent } from './routes/dashboard/dashboard.component';
import { AppSideLoginComponent } from './shared/pages/authentication/side-login/side-login.component';
import { authGuard } from './core/guard/auth.guard';
export const routes: Routes = [
  {
    path: '', redirectTo: 'auth', pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./shared/pages/authentication/authentication.routes').then(
        (m) => m.AuthenticationRoutes
      ),
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: '/admin/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'agents', component: AgentListComponent
      },
      {
        path: 'leads-list', component: LeadsListComponent
      },

      // {
      //   path: 'property-list', component: PropertyListComponent
      // },

      {
        path: 'user-list', component: UserListComponent
      },
      // {
      //   path: 'support',
      //   loadChildren: () => import('./routes/support/support.routes').then((m) => m.SupportRoutes)
      // },

      {
        path: 'leaderboard-list', component: LeaderBoardListComponent
      },
      {
  path: 'user-recordings',
  component: UserRecordingComponent
},
      {
        path: 'tutorial',
        loadChildren: () => import('./routes/tutorial/tutorial.routes').then((m) => m.TutorialRoutes)
      },

      // {
      //   path: 'settings',
      //   loadChildren: () => import('./module/settings/settings.routes').then((m) => m.SettingsRoutes)
      // }
      // {
      //   path: 'ui-components',
      //   loadChildren: () =>
      //     import('./pages/ui-components/ui-components.routes').then(
      //       (m) => m.UiComponentsRoutes
      //     ),
      // },
      // {
      //   path: 'extra',
      //   loadChildren: () =>
      //     import('./pages/extra/extra.routes').then((m) => m.ExtraRoutes),
      // },
    ],
  },

  {
    path: '**',
    redirectTo: 'auth',
  },
];
